<sew-ws-header
    #header
    oscHeaderEvents
    [baseUrl]="baseURL"
    breadcrumbId="sp"
    [useTracking]="true"
    [useCMP]="useCMP"
    [environment]="stage"
    [clientId]="authConfig.clientId"
    [policy]="authConfig.policy"
    [scopes]="authConfig.scopes"
    [redirectUri]="postLoginUrl"
    [postLogoutRedirectUri]="postLogoutUrl"
></sew-ws-header>
<ecs-loading-layer></ecs-loading-layer>

<div class="page-container">
    @if (hasSidePanel && (overlayService.overlayStateOpen | async)) {
        <div class="absolute-wrapper">
            <div class="overlay-content-sticky">
                <ecs-overlay-right></ecs-overlay-right>
            </div>
        </div>
    }
    <sew-ws-content-wrapper>
        <router-outlet></router-outlet>
    </sew-ws-content-wrapper>
</div>
@if (contactButtonUrl.length > 0) {
    <sew-ws-floating-buttons-contact-options [contactApiUrl]="contactButtonUrl">
    </sew-ws-floating-buttons-contact-options>
}

@if (language.length > 0 && countryCode.length > 0) {
    <sew-ws-footer-api
        [caasBaseUrl]="caasBaseUrl"
        [countryCode]="countryCode"
        [language]="language.toUpperCase()"
        [displayNewestBlogPost]="displayFooterBlogPost"
    >
        @for (link of footerLinks; track link) {
            <a slot="additional-legal-links" [href]="link.url" [target]="link.target"> {{ link.text }}</a>
        }
    </sew-ws-footer-api>
}
